import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import './helpers/Firebase';
import AppLocale from './lang';
import ColorSwitcher from './components/common/ColorSwitcher';
import NotificationContainer from './components/common/react-notifications/NotificationContainer';
import { isMultiColorActive } from './constants/defaultValues';
import main from './views';
import app from './views/app';
import user from './views/user';
import Callback from './views/user/callback';
import error from './views/error';
import { getDirection } from './helpers/Utils';
import userManager from './helpers/userManage';
import { withRouter } from 'react-router-dom';
import cloudBeds from './views/app/pages/cloudBeds';
const AuthRoute = ({ component: Component, authUser, ...rest }) => {
  if (authUser.user) {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }

  // console.log(rest.location.pathname);
  userManager.signinRedirect({
    data: { path: rest.location.pathname },
  });
  return <div />;

  // return (
  //   <Route
  //     {...rest}
  //     render={props =>
  //       authUser.user ? (
  //         <Component {...props} />
  //         // ) : (
  //         //   <Redirect
  //         //     to={{
  //         //       pathname: "/user/login",
  //         //       state: { from: props.location }
  //         //     }}
  //         //   />
  //         // )
  //       ) : <>{setTimeout(() => {
  //         userManager.signinRedirect({
  //           data: { path: rest.location.pathname },
  //         })
  //       }, 0)}
  //           < div />
  //         </>
  //     }
  //   />
  // )
};

class App extends Component {
  componentWillMount() {
    const direction = getDirection();
    if (direction.isRtl) {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
  }

  // shouldComponentUpdate(nextProps) {
  // }

  render() {
    let url = this.props.history.location.pathname;

    if (url === '/callback') {
      return <Callback {...this.props} />;
    }

    const { locale, loginUser, oidc } = this.props;

    const currentAppLocale = AppLocale[locale];
        
      if (
      oidc.user === null &&
      !url.includes('/user/register') &&
      !url.includes('/app/pages/tokens') &&
      !url.includes('/user/forgot-password') &&
      !url.includes('/user/reset-password') &&
      !url.includes('/user/forgot-pin') &&
      !url.includes('/user/reset-pin') &&
      !url.includes('/user/unsubscribe') &&
      !url.includes('/user/signup') &&
      !url.includes('/user/vouchersignup') &&
      !url.includes('/user/booking') &&
      !url.includes('/app/pages/stripe') &&
      !url.includes('/app/pages/cloudbeds') &&
      !url.includes('/app/pages/standard-stripe') &&
      !url.includes('/user/invitations')      
    ) {
      userManager.signinRedirect({
        data: { path: url },
      });
      return <div />;
    }
    else if (!oidc.isLoadingUser && oidc.user) {
      return (
        <div className="h-100">
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}
          >
            <React.Fragment>
              <NotificationContainer />
              {/* {isMultiColorActive && <ColorSwitcher />} */}
              <Router>
                <Switch>
                  <Route path="/app" authUser={oidc} component={app} />
                  <Route path="/user" component={user} />
                  <Route path="/error" exact component={error} />
                  <Route path="/" exact component={main} />
                  <Redirect to="/error" />
                </Switch>
              </Router>
            </React.Fragment>
          </IntlProvider>
        </div>
      );
    }    
    else {
      return (
        <div className="h-100">
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}
          >
            <React.Fragment>
              <NotificationContainer />
              {/* {isMultiColorActive && <ColorSwitcher />} */}
              <Router>
                <Switch>
                  <Route path="/user" component={user} />      
                  <Route path="/app/pages/cloudbeds" component={cloudBeds} />              
                </Switch>
              </Router>
            </React.Fragment>
          </IntlProvider>
        </div>
      );
    }
  }
}

const mapStateToProps = ({ authUser, settings, oidc }) => {
  const { user: loginUser } = authUser;
  const { locale } = settings;
  return { loginUser, locale, oidc };
};
const mapActionsToProps = {};

const AppStore = connect(mapStateToProps, mapActionsToProps)(App);

export default withRouter(AppStore);
